
let pathName = window.location.pathname;
if (pathName == '/cart') {
    console.log("work");
    sessionStorage.setItem('came_from_cart', 'true');
}
window.addEventListener('pageshow', function (event) {
    if (pathName.includes('/products')) {
        let comeFromCart = sessionStorage.getItem('came_from_cart'); 
        console.log(comeFromCart);
        
        if (event.persisted && comeFromCart === 'true') {
            sessionStorage.removeItem('came_from_cart');
            window.location.reload();
    }
    }
});
